export const config = {
  serverRoutePrefix: 'apigateway/',
  appVersion: 'v2'
};